import {Spin} from "antd";

export default function FundamarketsLoadingScreen() {

    return (
        <div id={"fundamarkets-loading-screen"} className={"w-full flex"} style={{height: "100vh"}}>
            <Spin size={"large"} className={"m-auto"}/>
        </div>
    );
}